import { css } from '@emotion/react'

export const wrapper = css`
  display: flex;
  flex-direction: column;
  gap: 14px;
`

export const label = css`
  margin-bottom: 0px;
`
